import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface ICouponSectionProps {
  $bgColor?: string;
  $textColor?: string;
}

export const CouponSection2 = styled.div<ICouponSectionProps>`
  padding: 32px 20px;
  text-align: center;
  background: #fff;

  &.bg-type-black {
    background: #000;

    .main-title {
      color: #fff;
    }
  }

  ${({ $bgColor, $textColor }) =>
    ($bgColor || $textColor) &&
    css`
      background-color: ${$bgColor};
    `}

  .section-title {
    padding-left: 0;
    padding-right: 0;
  }

  .text {
    text-align: left;
  }

  .notice-bar {
    margin-bottom: 14px;
  }

  .coupon-wrap {
    margin-bottom: 20px;

    .item + .item {
      margin-top: 8px;
    }
  }

  .event-notice {
    padding-top: 20px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32 20')};

    .notice-bar {
      margin-bottom: ${mixin.pxToVw('14')};
    }

    .coupon-wrap {
      margin-bottom: ${mixin.pxToVw('20')};

      .item + .item {
        margin-top: ${mixin.pxToVw('8')};
      }
    }

    .event-notice {
      padding-top: ${mixin.pxToVw('20')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 65px 57px;

    &.align-left .coupon-wrap {
      justify-content: flex-start;
    }

    .notice-bar {
      margin-bottom: 40px;
    }

    .coupon-wrap {
      ${mixin.flex({
        wrap: 'wrap',
        justify: 'center',
      })};
      gap: 18px;
      margin: 0;

      .item + .item {
        margin-top: 0;
      }

      .coupon-item {
        width: 430px;

        .text-wrap {
          width: calc(100% - 80px);
          padding: 19px 46px 19px 24px;

          &:before,
          &:after {
            right: 75.5px;
          }
        }

        .btn {
          width: 80px;
        }
      }
    }

    .event-notice {
      padding-top: 30px;
    }
  }
`;
